import { IComponentProps } from "@starrez/starryui";

export * from "./SnackBarContext";

export interface ISnackBarContext {
    AddMessage?: (content: IComponentProps) => void;
}

export interface ISnackBarContextProviderProps {
    children: React.ReactNode;
}
